<script>
import FormDefault from "../../Utils/Page/FormDefault";

export default {
    name: "Form",
    mixins: [FormDefault],
    data() {
        return {
            lang: this.$ml.get('pages.partner_promo_code'),

            buttons: [
                { key: 'generate', class: 'btn-primary', function: this.generateCode },
            ],

            typeForm: {
                promo_owner_id: 'select',
                company_id: 'select',
                plan_id: 'select',
                user_id: 'select',
                partner: 'select',
                type: 'select',
                activated: 'boolean',
                activated_at: 'string',
            },

            element: {
                activated: false,
                code: null,
            },

            pageRouteList: 'partner_promo_code',
            pageRouteEdit: 'partner_promo_code.edit',
            pageApi: 'marketing.partner_promo_code',
            pagePermission: 'marketing.partner_promo_code',
        }
    },
    methods: {
        generateCode() {
            this.$store.commit('setLoading', true)
            axios
                .post(this.$store.getters.getApiUrl('marketing.partner_promo_code.generate'))
                .then(({data}) => {
                    if (data.success) {
                        this.element.code = data.code
                    }
                })
                .finally(() => {
                    this.$store.commit('setLoading', false)
                })
        },
        getClass(key) {
            if (['description', 'note'].includes(key)) {
                return 'w50'
            }
            return 'w33'
        },
        getSelectLabel(label) {
            if (label === 'promo_owner_id' || label === 'user_id' || label === 'parent_id') {
                return 'name'
            }
            if (label === 'company_id') {
                return 'company_name'
            }
            return 'title'
        },
    }
}
</script>

<style scoped>

</style>
